<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">Request Hourly Leave</h5>
    <form [formGroup]="AddNewOfftime" (submit)="SubmitAddNewOfftime()">

      <input type="hidden" formControlName="id" />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">From Time </label>

          <div class="row">
            <div class="form-group col-md-4">
              <select formControlName="startDate_Min" class="custom-select">
                <option value="{{item}}" *ngFor="let item of MinList">{{item}}</option>
              </select>
            </div> 
            :
            <div class="form-group col-md-4">
              <select formControlName="startDate_Hour" class="custom-select">
                <option value="{{item}}" *ngFor="let item of HourList">{{item}}</option>
              </select>
            </div>

          </div>

        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">To Time </label>
          <div class="row">
            <div class="form-group col-md-4">
              <select formControlName="endDate_Min" class="custom-select">
                <option value="{{item}}" *ngFor="let item of MinList">{{item}}</option>
              </select>
            </div> 
            :
            <div class="form-group col-md-4">
              <select formControlName="endDate_Hour" class="custom-select">
                <option value="{{item}}" *ngFor="let item of HourList">{{item}}</option>
              </select>
            </div>

          </div>

        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Requested Date </label>
          <input formControlName="requestDate" #vaziat_rerequestDateInput type="text" class="form-control"
            placeholder="Type here...">
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="vaziat_rerequestDateInput"></ng-persian-datepicker>
        </div>


      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input formControlName="dsc" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_dsc().valid && get_Form_dsc().touched"
            class="form-text text-muted MyErrorRedColor">Enter the description.</small>
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit"  [disabled]="!AddNewOfftime.valid" class="btn btn-success"
        style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Confirm and Save </button>
      <button routerLink="/OffTime" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> Back </button>
    </form>
  </div>
</div>



